<template>
    <div class="his-data">
        <page-header></page-header>
        <div class="his-data-option set-option">
            <div>
                <template>
                    <el-select class="charts-input" v-model="option.sys_alias" @change="loadHisData" placeholder="请选择">
                        <el-option v-for="item in sys_alias" :key="item.val" :label="item.label" :value="item.val">
                        </el-option>
                    </el-select>
                </template>
                <template>
                    <el-select class="charts-input" v-model="hisData.timeType" placeholder="请选择">
                        <el-option v-for="item in timeOpt" :key="item.val" :label="item.label" :value="item.val">
                        </el-option>
                    </el-select>
                </template>

            </div>
            <div>
                <template>
                    <el-date-picker v-model="option.date" :type="option.dateType" @change="changeOption"
                                    placeholder="选择日期时间" align="right">

                    </el-date-picker>
                </template>

            </div>
            <div class="charts-input" style="text-align:right">
                <el-button type="primary" :loading='loading.table' @click="loadHisData()">
                    {{loading.table ? '正在加载' : '刷新数据'}}
                </el-button>
            </div>
        </div>
        <el-row>
            <el-col :span="24">
                <el-card v-if='chartsData.xData.length>0' class="box-card  css-margin-top">
                    <div class="clearfix chars-header">
                        <span class="card-header-title">产量图表</span>
                    </div>
                    <loading v-show="loading.chart"></loading>
                    <div v-show="!loading.chart">
                        <div v-if='chartsData.xData.length==0' class="img-no-data">
                            <img :src="img_no_data" alt="暂无数据">
                            <p>暂无数据</p>
                        </div>
                        <div v-else ref="charts"></div>
                    </div>
                </el-card>
                <el-card class="box-card  css-margin-top no-padding">
                    <div slot="header" class="clearfix chars-header">
                        <span class="card-header-title">产量报表</span>
                        <div>
                            <el-button @click="exportExcelFn" type="text">下载Excel</el-button>
                        </div>
                    </div>
                    <div style="padding:0;position:relative">
                        <div v-if="loading.table">
                            <loading></loading>
                        </div>
                        <div class="table-responsive" ref="hisTable" v-else>
                            <table v-if='hisData.data.length' class="table table-responsive">
                                <thead>
                                <tr>
                                    <th v-for="th in tableHeader" :key="th.id">{{th.name}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(td,index) in hisData.data" :key="td.id">
                                    <td v-for="th in tableHeader" :key="th.id">
                                        <span v-if='th.key==="leiji"'>{{index + 1}}</span>
                                        <span
                                            v-else-if='th.key==="date"&&hisData.timeType!=="by_month"'>{{momentYear(td[th.key])}}</span>
                                        <span
                                            v-else-if='th.key==="rate"||th.key==="heat"||th.key==="interval"'>{{td[th.key] ? (td[th.key].toFixed(0)) : 0}}</span>
                                        <span v-else>{{td[th.key] ? td[th.key] : 0}}</span>
                                    </td>
                                </tr>
                                <tr v-if='hisData.timeType!=="by_day"'>
                                    <td>平均</td>
                                    <td>
                                        {{hisData.average.interval ? hisData.average.interval.toFixed(0) : 0}}
                                    </td>
                                    <td>
                                        {{hisData.average.counter ? hisData.average.counter.toFixed(0) : 0}}
                                    </td>
                                    <td>
                                        {{hisData.average.heat ? hisData.average.heat.toFixed(2) : 0}}
                                    </td>
                                    <td>
                                        {{hisData.average.rate ? hisData.average.rate.toFixed(2) : 0}}
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                            <div style='line-height:40px' v-else>
                                暂无数据
                            </div>

                        </div>
                        <div class="arrow" v-if="isMobile&&hisData.data.length">
                            <img style="transform:rotate(180deg)" @touchstart="setScroll('left')" :src="img_arrow"
                                 alt="">
                            <img @touchstart="setScroll('right')" :src="img_arrow" alt="">
                        </div>
                    </div>
                </el-card>

            </el-col>
        </el-row>
    </div>
</template>
<script>
    const echarts = require("echarts");
    import {mapState} from "vuex";
    import moment from "moment";
    import Lib from "../../lib/lib.js";
    import img_no_data from "../../assets/images/no_data.svg";
    import img_arrow from "../../assets/images/arrow.png";

    import dataPicker from "../../components/common/datePick";
    import pageHeader from "../../components/tempControl/header";
    import loading from "../../components/common/loading";

    export default {
        name: "historyData",
        components: {
            pageHeader,
            dataPicker,
            loading
        },
        data() {
            return {
                img_no_data,
                img_arrow,
                option: {
                    sys_alias: 1,
                    date: moment().format("YYYY-MM-DD"),
                    dateType: "date"
                },
                sys_alias: [],
                loading: {
                    chart: true,
                    table: true
                },
                // echarts实例
                charts: "",
                timeOpt: [
                    {
                        label: "年报表",
                        val: "by_year"
                    },
                    {
                        label: "月报表",
                        val: "by_month"
                    },
                    {
                        label: "日报表",
                        val: "by_day"
                    }
                ],
                hisData: {
                    timeType: "by_day",
                    data: [],
                    average: []
                },
                chartsData: {
                    xData: [],
                    proData: [],
                    passData: []
                },
                tableHeader: [],
                dayHeader: [
                    {name: "进车开始时间", key: "startDate"},
                    {name: "进车时间（分）", key: "carInTime"},
                    {name: "进车间隔", key: "carInIntervalTime"},
                    {name: "操作员姓名", key: "name"},
                    {name: "累计进车数", key: "leiji"},
                    {name: "发热量（kc/kg）", key: "heat"},
                    {name: "合格率（％）", key: "rate"}
                ],
                monthHeader: [
                    {name: "日期", key: "date"},
                    {name: "进车平均间隔", key: "interval"},
                    {name: "进车数", key: "day_counter"},
                    // { name: '累计进车数', key: 'sumleiji' },
                    {name: "发热量平均", key: "heat"},
                    {name: "平均合格率", key: "rate"}
                ],
                yearHeader: [
                    {name: "日期", key: "date"},
                    {name: "进车平均间隔", key: "interval"},
                    {name: "进车数", key: "counter"},
                    // { name: '累计进车数', key: 'sumleiji' },
                    {name: "发热量平均", key: "heat"},
                    {name: "平均合格率", key: "rate"}
                ]
            };
        },
        created() {
            this.creatAliasMeun(this.deviceInfo.alias_m);
        },
        mounted() {
            this.loadHisData();
            Lib.M.selectInputFoc();
        },
        watch: {
            "hisData.timeType"() {
                this.changeOption();
            }
        },

        computed: mapState({
            isMobile: state => state.isMobile,
            userInfo: state => state.userInfo,
            deviceInfo: state => state.deviceInfo,
            siderbarOpen(state) {
                setTimeout(() => {
                    this.charts.resize();
                }, 400);
                return state.siderbarOpen;
            }
        }),

        methods: {
            momentYear(data) {
                return moment(data).format("YYYY-MM");
            },
            /**
             * 创建窑号选框
             * @argument MaxAlias 最大窑数
             */
            creatAliasMeun(MaxAlias) {
                for (let i = 0; i < MaxAlias; i++) {
                    this.sys_alias.push({
                        val: i + 1,
                        label: `${i + 1}号窑`
                    });
                }
            },
            /**
             * 用户修改时间，时间类型，窑号
             * @argument type 修改option类型
             */
            changeOption(type) {
                if (this.hisData.timeType === "by_day") {
                    this.option.dateType = "date";
                } else {
                    this.option.dateType = this.hisData.timeType.split("by_")[1];
                }
                this.loadHisData();
            },
            loadHisData() {
                this.loading.table = true;
                // this.option.date = moment(this.option.date).format("YYYY-MM-DD")
                let params = {
                    device_id: this.deviceInfo.device_id,
                    data_type: "proData",
                    sys_alias: this.option.sys_alias,
                    date: moment(this.option.date).format("YYYY-MM-DD"),
                    time_type: this.hisData.timeType
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }

                if (!params.date) {
                    params.date = "2011-02-01";
                }
                Lib.api.loadDeviceData(params, data => {
                    this.loading.chart = false;
                    this.loading.table = false;
                    if (data.status_code === "SUCCEEDED") {
                        console.log(data.payload);

                        if (data.payload && data.payload) {
                            try {
                                // 整理表格数据
                                this.hisData.data = this.parseJsonArr(data.payload);
                                // 整理图表数据
                                this.chartsDataFn(this.hisData.data);
                                this.$nextTick(() => {
                                    if (
                                        this.hisData.timeType &&
                                        this.hisData.timeType !== "by_day"
                                    ) {
                                        this.initChart();
                                    }
                                });
                            } catch (error) {
                                console.error({
                                    msg: "产量数据解析错误",
                                    data: data,
                                    error: error
                                });
                            }
                        } else {
                            this.hisData.data = [];
                        }
                    } else {
                        this.$message(data.msg);
                    }
                });
            },

            // 导出
            exportExcelFn() {
                let params = {
                    device_id: this.deviceInfo.device_id,
                    data_type: "proData",
                    sys_alias: this.option.sys_alias,
                    date: moment(this.option.date).format("YYYY-MM-DD"),
                    time_type: this.hisData.timeType
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }

                let url = `${Lib.C.APIhost}/devices/${this.deviceInfo
                    .device_id}/pro_export?device_id=${this.deviceInfo
                    .device_id}&data_type=proData&sys_alias=${this.option
                    .sys_alias}&date=${moment(this.option.date).format(
                    "YYYY-MM-DD"
                )}&time_type=${this.hisData.timeType}&auth_token=${params.auth_token
                    ? params.auth_token
                    : ""}${params.customer_token ?('&customer_token='+ customer_token) : ""}`;
                window.open(url);
            },
            // 用于解析历史统计数据
            parseJsonArr(arr) {
                let resArr = [];
                if (this.hisData.timeType === "by_day") {
                    this.tableHeader = this.dayHeader;
                    arr.forEach(function (item) {
                        try {
                            resArr.push(JSON.parse(item.data));
                        } catch (error) {
                            console.error({
                                error: error,
                                msg: "日产量数据解析失败",
                                data: item.data
                            });
                        }
                    }, this);
                } else {
                    this.tableHeader =
                        this.hisData.timeType === "by_month"
                            ? this.monthHeader
                            : this.yearHeader;
                    resArr = arr.data;
                    this.hisData.average = JSON.parse(arr.average);
                }
                return resArr;
            },

            /**
             * 处理生成图表数据
             * @arg data 产量数据
             */
            chartsDataFn(data) {
                // this.chartsData = data
                let xData = [],
                    countData = [],
                    rateData = [];

                if (this.hisData.timeType === "by_month") {
                    let monthDays = moment(this.option.date).daysInMonth();
                    for (let i = 1; i <= monthDays; i++) {
                        xData.push(i);
                        countData.push(0.1);
                    }
                    data.forEach(item => {
                        let d = moment(item.date).format("D") * 1 - 1,
                            x = xData[d];
                        if (x) {
                            countData[x - 1] = item.day_counter
                                ? item.day_counter
                                : item.counter;
                        }
                    });
                } else if (this.hisData.timeType === "by_year") {
                    for (let i = 1; i <= 12; i++) {
                        xData.push(i);
                        countData.push(0.1);
                    }
                    data.forEach(item => {
                        let m = moment(item.date).format("M") * 1,
                            x = xData[m - 1];
                        if (x) {
                            countData[m - 1] = item.day_counter
                                ? item.day_counter
                                : item.counter;
                        }
                    });
                }

                this.chartsData = {
                    xData,
                    countData
                };
            },

            initChart() {
                let chartsData = this.chartsData;
                let charts;

                let xAxisData = [];
                let data1 = [];

                for (var i = 0; i < 12; i++) {
                    xAxisData.push(i);
                    data1.push((Math.random() + 2) * 100);
                }
                let option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#283b56"
                            }
                        }
                    },
                    legend: {
                        data: ["进车数"],
                        align: "left",
                        bottom: 20
                    },

                    xAxis: {
                        show: true,

                        data: chartsData.xData,
                        silent: false,
                        splitLine: {
                            show: false
                        }
                    },
                    yAxis: {
                        show: "true",
                        type: "value",
                        name: "进车数",
                        max: this.hisData.timeType === "by_year" ? "800" : "50"
                    },
                    series: {
                        name: "进车数",
                        type: "bar",
                        data: chartsData.countData,
                        animationDelay: function (idx) {
                            return idx * 10;
                        },
                        itemStyle: {
                            normal: {
                                color: "#ff8283"
                            },
                            emphasis: {
                                color: "#ff5653"
                            }
                        },
                        barCategoryGap: "40%"
                    },
                    animationEasing: "elasticOut",
                    animationDelayUpdate: function (idx) {
                        return idx * 5;
                    }
                };
                if (this.$refs.charts) {
                    charts = echarts.init(this.$refs.charts, charts, {
                        height: 400
                    });
                    charts.setOption(option);
                }

                this.charts = charts;
            },
            setScroll(type) {
                let hisTable = this.$refs.hisTable,
                    scrollLeft = this.$refs.hisTable.scrollLeft;
                if (type === "right") {
                    hisTable.scrollLeft = scrollLeft + 80;
                } else {
                    hisTable.scrollLeft = scrollLeft - 80;
                }
            }
        }
    };
</script>

<style scoped>
    .chars-header {
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .card-header-title > span {
        font-size: 0.12rem;
    }

    .his-data-option {
        display: flex;
        justify-content: space-between;
    }

    .his-data-option .el-select {
        width: 140px;
    }

    .his-data-option > div:nth-child(2) {
        text-align: center;
    }

    .his-data-option > * {
        flex: 1;
    }

    .table-responsive {
        position: relative;
    }

    .arrow {
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        height: 25px;
        justify-content: space-between;
    }

    @media screen and (max-width: 900px) {
        .his-data-option {
            flex-direction: column;
        }

        .his-data-option > div:nth-child(2) {
            text-align: left;
            margin-top: 20px;
            width: 40%;
        }

        .table > thead > tr > th {
            vertical-align: bottom;
            border-bottom: 2px solid #ddd;
            width: 100px;
        }
    }
</style>
<style>
    .his_data th,
    td {
        font-size: 0.18rem;
    }

    .his_data .table-time {
        font-size: 0.1rem;
    }
</style>




// WEBPACK FOOTER //
// historyData.vue?086e5370